import { createFileRoute } from "@tanstack/react-router";
import { buildRouteHead } from "@/lib/seo/routeHead";
import ServicePage from "@/pages/ServicePage";

export const Route = createFileRoute("/es/servicios/lab-services/")({
  head: () => buildRouteHead("/es/servicios/lab-services"),
  component: ServicePage,
});

